/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgTickets } from '../../models/esg-tickets';
import { EsgTicketsFieldsFilter } from '../../models/esg-tickets-fields-filter';

export interface EsgTicketListForEsg$Params {
  profileId: number;
  year: number;
  code: string;
  includeFields?: Array<EsgTicketsFieldsFilter>;
}

export function esgTicketListForEsg(http: HttpClient, rootUrl: string, params: EsgTicketListForEsg$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
  const rb = new RequestBuilder(rootUrl, esgTicketListForEsg.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.query('includeFields', params.includeFields, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EsgTickets>;
    })
  );
}

esgTicketListForEsg.PATH = '/esg/profile/{profileId}/esg/{year}/{code}/ticket';
